export const DESTINATIONS_FILENAME_TEMPLATES = [
  '{{orgId}}/{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.csv',
  '{{orgId}}/{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.json',
  '{{orgId}}/{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.parquet',
  '{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.csv',
  '{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.json',
  '{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.parquet',
];
